import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button } from '@components-library/Button';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import styles from './404.module.scss';

export const Page404 = ({ redirectTo, callback }: { redirectTo?: string; callback?: () => void }) => {
  const history = useHistory();

  const { i18n } = useTranslation();

  const handleButton = () => {
    callback?.();

    redirectTo && history.replace(redirectTo);
  };

  return (
    <div className={styles.pageNotFound}>
      <div className={styles.pageNotFoundWrapper}>
        <div className={styles.pageNotFoundTextWrapper}>
          <h2 className={styles.pageNotFoundTitle}>{i18n.t(keyMap.sharedSystemNotFoundPageTitle)}</h2>
          <p className={styles.pageNotFoundSubtitle}>{i18n.t(keyMap.sharedSystemNotFoundPageSubtitle)}</p>
        </div>
        <Button onClick={handleButton} className={cn(styles.pageNotFoundButton, 'form__button')}>
          {i18n.t(keyMap.sharedSystemNotFoundPageButton)}
        </Button>
      </div>
    </div>
  );
};
